import React, { useEffect, useState } from 'react';
import WeeklyCalendar from '../../../components/weekly-calendar/WeeklyCalendar';
import Calendar from '../../../components/Calendar/Calendar';
import { useUniversalFind } from '../../../hooks/universal';
import { format } from 'date-fns';
import { Appointments, EventType } from '../../../misc/types';
import { accessGlobalUserState } from '../../../stores/user';
import { updateLocalStateRaw, userHasRole } from '../../../misc/utils';
import { useAllUsersWithAppointments } from '../../../hooks/psychologist';
import { useGlobalMiscState } from '../../../stores/misc';
import { psychologistTabs } from '../../../misc/constants';
import { useHookstate } from '@hookstate/core';
import { PsychologyList } from './PsychologyList';

export const PsychologyAdmin = () => {
    const miscState = useGlobalMiscState();
    const localState = useHookstate({});
    const state: Record<string, any> = localState.get();
    const currentTab = state.currentTab || "calendar";
    const psychologyCalendarTriggerFetch = miscState.get('psychologyCalendarTriggerFetch') || 0;
    // const selectedPsychologist = miscState.get('psychologyAdminSelectedPsychologist') || {};
    const userState = accessGlobalUserState()
    const user = userState.get()
    const uniqUser = user.uniqUser || {}
    const [localEvents, setLocalEvents] = useState<EventType[]>([]);

    const [selectedPsychologist, setSelectedPsychologist] = useState<any>({});

    const allUsersWithAppointments = useAllUsersWithAppointments(psychologyCalendarTriggerFetch)

    const updateTab = (key: string) => () => {
        updateLocalStateRaw(localState, 'currentTab')(key)
    }

    useEffect(() => {
        if (allUsersWithAppointments.length) {
            // miscState.set('psychologyAdminSelectedPsychologist', allUsersWithAppointments[0]);
            setSelectedPsychologist(allUsersWithAppointments[0]);
        }
    }, [allUsersWithAppointments.length])

    const appointments: Appointments = selectedPsychologist.psychologist_appointments || [];

    // const appointments = useUniversalFind(
    //     'PsychologistAppointment',
    //     isAdmin ? {} : {
    //         main_user_id: uniqUser.id
    //     },
    //     {
    //         include: [
    //             {
    //                 model: 'PsychologistAppointmentClient',
    //                 as: 'clients',
    //                 include: ['client_user'],
    //             },
    //         ],
    //     }
    // ) as Appointments | null;
    //console.log(appointments)
    console.log(selectedPsychologist)
    const eventsFromServer = appointments.map(appointment => {
        const clients = appointment?.clients
            ?.filter(c => [-1, 0, 1, 2].includes(c.status))
            ?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()) || []
        const client = clients[0]?.client_user;
        const first = client?.json_saved_data?.firstname || '';
        const last = client?.json_saved_data?.lastname || '';
        const body: EventType = {
            id: appointment.id,
            title: client
                ? `${first} ${last}`.trim() || 'Занято'
                : 'Свободное время',
            start: format(new Date(appointment.start_time), 'HH:mm'),
            end: format(new Date(appointment.end_time), 'HH:mm'),
            day: new Date(appointment.start_time),
            canceled: appointment.status === -1,
            appointment
        };
        if (client) {
            body.client = client.json_saved_data;
            body.clientSelf = clients[0];
        }
        return body;
    })

    useEffect(() => {
        setLocalEvents(eventsFromServer);
    }, [eventsFromServer.length]);

    return (
        <div className="bg-[#f8f9fd] h-full text-black p-5 text-sm flex flex-col gap-4 overflow-y-auto">
            <div className="flex flex-row self-start bg-white rounded-xl p-2 gap-3">
                {psychologistTabs.map(t => {
                    const isActive = currentTab === t.key;
                    const Icon = t.icon;
                    return (
                        <div key={t.key} className={`flex flex-row ${isActive && 'bg-valley-main'} gap-[6px] px-2 py-1.5 items-center rounded-lg cursor-pointer`} onClick={updateTab(t.key)}>
                            <Icon additionalStyle={isActive ? 'text-white' : 'text-valley-main'} />
                            <span className={`font-medium leading-[19.2px] ${isActive ? 'text-white' : 'text-valley-black'}`}>
                                {t.label}
                            </span>
                        </div>
                    )
                })}
            </div>
            <div className='flex flex-row gap-4 flex-1 overflow-y-auto'>
                {currentTab === "calendar" && (
                    <React.Fragment>
                        <Calendar mode='admin' selectedPsychologist={selectedPsychologist} setSelectedPsychologist={setSelectedPsychologist} allUsersWithAppointments={allUsersWithAppointments} localEvents={localEvents} />
                        <WeeklyCalendar mode='admin' setLocalEvents={setLocalEvents} localEvents={localEvents} />
                    </React.Fragment>
                )}
                {currentTab === "list" && (
                    <React.Fragment>
                        <Calendar mode='admin' allUsersWithAppointments={allUsersWithAppointments} localEvents={localEvents} />
                        <PsychologyList localEvents={localEvents} />
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}